module.exports = __webpack_public_path__ + "static/img/Jamayne-Isaako.780c906.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Jamayne-Isaako.jpg
// module id = lxDV
// module chunks = 0